import React from 'react';
import { Card, Table } from 'antd';
import type { WorkstationControlCenterQueryParams } from '@/services/workstationControlCenter.service';
import { useWccHours } from '@/hooks/useWorkstationControlCenter';

interface Props {
  params?: WorkstationControlCenterQueryParams;
}

const HoursAnalysisCenter: React.FC<Props> = ({ params }) => {
  const { data, isLoading } = useWccHours(params);
  const rows = (data as { rows?: Record<string, unknown>[] })?.rows ?? [];

  return (
    <Card id="hours" title="Hours analysis" style={{ marginTop: 16 }}>
      <Table
        size="small"
        loading={isLoading}
        rowKey="workstation_id"
        dataSource={rows}
        columns={[
          { title: 'Workstation', dataIndex: 'workstation_name' },
          { title: 'Dept', dataIndex: 'department' },
          { title: 'Available', dataIndex: 'available_hours' },
          { title: 'Worked', dataIndex: 'worked_hours' },
          { title: 'Idle', dataIndex: 'idle_hours' },
          { title: 'Blocked', dataIndex: 'blocked_hours' },
          { title: 'Maintenance', dataIndex: 'maintenance_hours' },
          { title: 'Setup', dataIndex: 'setup_hours' },
          { title: 'Overtime', dataIndex: 'overtime_hours' },
        ]}
        pagination={{ pageSize: 15 }}
      />
    </Card>
  );
};

export default HoursAnalysisCenter;
